function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { defineComponent, $prefix, $props, $setup } from "@opentiny/vue-common";
import PcTemplate from "./pc.js";
import MobileTemplate from "./mobile.js";
import MobileFirstTemplate from "./mobile-first.js";
var template = function template2(mode) {
  if ("pc" === (process.env.TINY_MODE || mode)) {
    return PcTemplate;
  }
  if ("mobile" === (process.env.TINY_MODE || mode)) {
    return MobileTemplate;
  }
  if ("mobile-first" === (process.env.TINY_MODE || mode)) {
    return MobileFirstTemplate;
  }
  return PcTemplate;
};
var DropdownMenu = defineComponent({
  name: $prefix + "DropdownMenu",
  componentName: $prefix + "DropdownMenu",
  props: _extends({}, $props, {
    multiStage: {
      type: Boolean,
      default: false
    },
    checkedStatus: {
      type: Boolean,
      default: false
    },
    visibleArrow: {
      type: Boolean,
      default: false
    },
    arrowOffset: {
      type: Number,
      default: 0
    },
    placement: {
      type: String,
      default: "bottom-end"
      // aui的默认值为bottom-start
    },
    popperClass: String,
    popperAppendToBody: {
      type: Boolean,
      default: true
    },
    activeColor: String,
    closeOnClickOutside: {
      type: Boolean,
      default: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    },
    direction: {
      type: String,
      default: "down"
    },
    duration: {
      type: [Number, String],
      default: 0.2
    },
    overlay: {
      type: Boolean,
      default: true
    },
    zIndex: [Number, String],
    maxHeight: {
      type: [Number, String],
      default: "400"
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    textField: {
      type: String,
      default: "label"
    }
  }),
  setup: function setup(props, context) {
    return $setup({
      props,
      context,
      template
    });
  }
});
var version = "2.10.0";
DropdownMenu.install = function(Vue) {
  Vue.component(DropdownMenu.name, DropdownMenu);
};
DropdownMenu.version = version;
export {
  DropdownMenu as default
};
